import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en/translation.json';
import translationAR from './locales/ar/translation.json';

import Cookies from 'js-cookie';
// the translations
// (tip move them in a JSON file and import them)

const options = {
  // order and from where user language should be detected
  order: [
    'cookie',
    'htmlTag',
    'querystring',
    'localStorage',
    'sessionStorage',
    'navigator',
    'path',
    'subdomain'
  ],

  // cache user language on
  // caches: ["localStorage", "cookie"],
  caches: ['cookie'],

  // optional htmlTag with lang attribute, the default is:
  htmlTag: document.documentElement,

  // optional set cookie options, reference:[MDN Set-Cookie docs](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie)
  cookieOptions: { path: '/', sameSite: 'strict' }
};

const resources = {
  en: {
    translation: translationEN
  },
  ar: {
    translation: translationAR
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    resources,
    lng: Cookies.get('i18next') || 'ar',
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    react: {
      useSuspense: false
    },
    // lng: document.querySelector("html").lang,
    // fallbackLng: "en",
    supportedLngs: ['ar', 'en'],
    detection: options,
    backend: {
      loadPath: './locales/{{lng}}/translation.json'
      // loadPath: './locales/{{lng}}/translation.json'
    }
    // keySeparator: false, // we do not use keys in form messages.welcome
    // react: {
    // 	useSuspense: false
    // },
  });

export default i18n;
